<template>
  <div>
    <a-form-item :wrapper-col="{ span: 24 }">
      <a-textarea
        :placeholder="placeholderText"
        :rows="rows"
        :style="{ color: validateStatus === 'error' ? 'red' : '' }"
        v-model.trim="inputValue"
        @blur="handleCpes"
      />
    </a-form-item>

    <a-form-item label="CPE总数" :style="{ display: 'inline-block', width: '50%' }">
      <span class="cpes-count">{{ cpesCount }}</span>
    </a-form-item>

    <a-form-item label="重复数量" :style="{ display: 'inline-block', width: '50%' }">
      <span class="cpes-count">{{ duplicateCpesCount }}</span>
    </a-form-item>
  </div>
</template>

<script>
import { analyzeCpes, formatCpeInputValue, maxCpeLines } from '@/utils/cpe'

export default {
  name: 'CommonCpeInput',
  props: {
    rows: {
      type: Number,
      default: 10
    },
    // import: 入库，SN|IMEI|IMEI；sn: 划拨，仅 SN
    mode: {
      type: String,
      default: 'sn',
      validator(value) {
        return ['import', 'sn'].includes(value)
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    value: {
      type: Object
    }
  },
  data() {
    const value = this.value || {}

    if (!value.inputValue && Array.isArray(value.data) && value.data.length > 0) {
      value.inputValue = formatCpeInputValue(value.data, this.mode)
    }

    return {
      inValue: {},
      cpesCount: 0,
      duplicateCpesCount: 0,
      inputValue: value.inputValue || '',
      data: value.data || [],
      validateStatus: 'success',
      errorMsg: ''
    }
  },
  computed: {
    placeholderText() {
      if (this.mode === 'import') {
        return '可以直接复制 excel 中整列 SN；\n' +
          '手动输入多个 CPE，一行一个 SN；\n' +
          '如需填写 IMEI，使用 SN|IMEI 或 SN|IMEI|IMEI 格式（支持 1 或 2 个 IMEI）。\n' +
          '例如: SN001234567 或 SN001234567|860123456789012|860123456789013'
      }

      return '可以直接复制 excel 中整列 SN；\n' +
        '手动输入多个 CPE，一行一个 SN。\n' +
        '例如: SN001234567'
    }
  },
  watch: {
    value(val = {}) {
      this.inputValue = val.inputValue
      this.data = val.data
    }
  },
  created() {
    if (this.value) {
      this.inValue = this.value
    }

    if (this.inputValue) {
      this.handleCpes()
    }
  },
  methods: {
    triggerChange() {
      this.$emit('change', Object.assign({}, this.$data))
    },

    handleCpes() {
      this.validateCpes()
      this.triggerChange()
    },

    validateCpes() {
      if (!this.inputValue) {
        this.validateStatus = 'error'
        this.errorMsg = '请输入CPE信息'
        this.cpesCount = 0
        this.duplicateCpesCount = 0
        this.data = []
        return
      }

      const { lines, validCpes, errorText } = analyzeCpes(this.inputValue, { mode: this.mode })

      if (lines > maxCpeLines) {
        this.validateStatus = 'error'
        this.errorMsg = `CPE数量不能超过${maxCpeLines}`
        return
      }

      if (errorText) {
        this.validateStatus = 'error'
        this.errorMsg = 'CPE信息包含错误，无法提交'
      } else {
        this.validateStatus = 'success'
        this.errorMsg = null
      }

      this.inputValue = errorText + formatCpeInputValue(validCpes, this.mode)
      this.cpesCount = validCpes.length
      this.data = this.$lodash.uniqBy(validCpes, 'sn')
      this.duplicateCpesCount = validCpes.length - this.data.length
    }
  }
}
</script>

<style lang="less" scoped>
.cpes-count {
  padding-left: 20px;
}
</style>
